import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20style%20artistic%20abstract%20composition%20with%20warm%20orange%20and%20coral%20tones%20soft%20gradient%20background%20minimalist%20elegant%20clean%20aesthetic%20digital%20art%20with%20subtle%20texture%20and%20gentle%20atmospheric%20glow&width=1920&height=900&seq=hero-bg-hanmanwu&orientation=landscape"
        alt="韩漫屋 - 韩国漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="韩漫屋 - 韩国漫画免费在线阅读平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          韩国漫画免费在线观看
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          下拉式韩漫阅读，高清画质大全。每日更新热门作品，轻松畅读精彩韩国漫画
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_4px_16px_rgba(0,0,0,0.2)]"
          >
            <i className="ri-book-read-line text-lg"></i>
            开始阅读
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-grid-line text-lg"></i>
            浏览分类
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">收录韩漫</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">99%</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">高清画质</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">日更</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">每日更新</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}